/* eslint-disable import/prefer-default-export */
import {fetcher} from './fetcher'

export const viewedUpdatedBankDetails = ({customerId}) => {
  const opts = {
    method: 'POST',
  }
  return fetcher(
    `/api/customers/${customerId}/viewed_updated_bank_details`,
    opts,
  )
}
